module.exports = __webpack_public_path__ + "img/mat_3.63d79d42.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1200,"height":894,"variants":[{"file":"img/mat_3-480w.af7785b8e707.webp","width":480},{"file":"img/mat_3-960w.b53cbc9c1c64.webp","width":960},{"file":"img/mat_3-1200w.fcd62d64835a.webp","width":1200}]};
}